<template>
  <div class="container">
    <div class="row mt-2">
      <div class="col d-flex justify-content-around align-items-center">
        <div class="dropdown">
          <button
            class="btn btn-secondary btn-sm dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Name
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li
              class="dropdown-item"
              href="#"
              v-for="n in names"
              :key="n"
              @click="setName(n)"
            >
              {{ n }}
            </li>
          </ul>
        </div>

        <input
          type="date"
          id="att_date"
          class="form-control date-field"
          placeholder="Date"
          :value="txn_date"
          @change="updateDate()"
        />
      </div>
    </div>
    <div class="row border align-items-center mt-2">
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model="name"
          placeholder="Name"
        />
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.number="att"
          placeholder="Hazri"
        />
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.number="rate"
          placeholder="Rate"
        />
      </div>
      <div class="col">
        <button class="btn btn-sm btn-primary" @click="addAttendance()">
          Add
        </button>
      </div>
    </div>
    <!-- <div class="row">
      {{ attendance_account }}
    </div> -->
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
const dayjs = require("dayjs");
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
import { db, auth } from "../../firebase/config";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { doc, updateDoc } from "firebase/firestore";
const { customAlphabet } = require("nanoid");
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const nanoid = customAlphabet(alphabet, 6);
const store = useStore();
var txn_date = ref(dayjs().format("YYYY-MM-DD"));
const rate = ref(0);
const att = ref(null);
const sortby = ref("desc");

const name = ref("");
const names = ref([]);
const attendance_account = ref({});

onBeforeUnmount(() => {});
onMounted(() => {
  attendance_account.value = store.accounts.find(
    (acc) => acc.attendance === true
  );
  populateNameList();
  getLastRate();
});

const populateNameList = () => {
  names.value = [];
  sorted_journal.value.forEach((sj) => {
    if (!names.value.includes(sj.n.split("#")[0]))
      names.value.push(sj.n.split("#")[0]);
  });
};
const getLastRate = () => {
  rate.value = sorted_journal.value[0].n.split("#")[2];
};

const updateDate = () => {
  txn_date.value = document.getElementById("att_date").value.trim();
};
const addAttendance = async () => {
  //const attendee = people.find(person => person.attendance === true);
  if (name.value && att.value && rate.value) {
    var txnObj = {
      n: name.value + "#" + att.value + "#" + rate.value, //note
      a: parseInt(att.value * rate.value), //amount
      t: "e", //txn type - i:income, e:expense
      p: null, //link to photo, if any
      d: txn_date.value + " " + dayjs().format("HH:mm:ss"), //transaction date, with time (for sorting) - need not be present date, can be past or future
    };

    const accountRef = doc(db, "accounts", attendance_account.value.id);
    await updateDoc(accountRef, {
      ["journal." + nanoid()]: txnObj,
    });
    setTimeout(() => {
      getLastRate();
      populateNameList();
    }, 3000);
    clearData();
  }
};
const clearData = () => {
  name.value = "";
  att.value = null;
};

function sortByField(arr, field) {
  if (sortby.value == "asc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] > b[field]) {
        return 1;
      } else if (a[field] < b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  if (sortby.value == "desc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] < b[field]) {
        return 1;
      } else if (a[field] > b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
}
const sorted_journal = computed(() => {
  var arr = [];
  // journal.value = [];
  store.accounts.forEach((account) => {
    //when no account is selected for entry
    if (account.id == attendance_account.value.id) {
      //get entries only for attendance account
      for (const property in account.journal) {
        arr.push({
          journal_id: property,
          ...account.journal[property],
        });
      }
    }
  });

  var sorted_arr = sortByField(arr, "d");
  return sorted_arr;
});
const setName = (n) => {
  if (name.value != n) {
    name.value = n;
  } else {
    name.value = "";
  }
};
</script>
<style scoped>
.date-field {
  width: auto;
  min-width: 125px; /* Ensures a reasonable default width */
  padding: 0.1rem 0.1rem; /* Matches default form-control padding */
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}
</style>
